export default "__VITE_ASSET__DVyciBJg__"